import it_IT from './it_IT.json';
import en_GB from './en_GB.json';

const messages = {
  'en-GB': en_GB,
  'it-IT': it_IT,
};

export default messages;
